const minuteMs = 60_000;
const hourMs = 3_600_000;
const dayMs = 86_400_000;
const weekMs = 7 * dayMs;
// Stamps fresher than this just read "now"; up to a minute old they count seconds.
const nowWindowMs = 5_000;

/** Feed age: seconds when fresh, relative under a week, then a short absolute date. */
export function feedTime(date: Date, now: Date): string {
  const diff = now.getTime() - date.getTime();
  if (diff < nowWindowMs) return "now";
  if (diff < minuteMs) return `${Math.floor(diff / 1_000)}s`;
  if (diff < hourMs) return `${Math.floor(diff / minuteMs)}m`;
  if (diff < dayMs) return `${Math.floor(diff / hourMs)}h`;
  if (diff < weekMs) return `${Math.floor(diff / dayMs)}d`;
  return shortDate(date, now);
}

export function shortDate(date: Date, now: Date = new Date()): string {
  if (date.getFullYear() === now.getFullYear()) {
    return date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  }
  return date.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

/** Focal stamps and relative-time tooltips: absolute, with seconds. */
/** Fresh stamps (about a minute either side of now) belong on the per-second ticker. */
export function isFresh(date: Date, now: Date): boolean {
  const diff = now.getTime() - date.getTime();
  return diff > -minuteMs && diff < minuteMs;
}

export function fullDate(date: Date): string {
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
  });
}
